export const OPEN_EXTEND_CONSTRACT_POLICY_SAVE_KEY = 'open_extend_contract_policy';
